module.exports = __webpack_public_path__ + "img/horizontal_6_4_7005.f3024b51.png";